import React from 'react'
import clsx from 'clsx'
import { merge } from 'lodash'
import { IconButton } from '@mui/material'
import { CloseCircle } from 'iconsax-react'

import Modal from '../../Modal'

import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import useStyles from './styles'

const resWidth = 'calc(100% - 4rem)'
const resHeight = 'calc(100% - 3rem)'

const basePaperProps = {
  style: {
    border: '1px solid #E5EAF1',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.15)',
    padding: '24px'
  }
}

const BaseModal = ({
  children,
  title = 'NEW CUSTOMER CHAT',
  PaperProps = undefined,
  PaperProps2 = undefined,
  className = undefined,
  showTitleOnMobile = false,
  variant = undefined,
  showX = true,
  hideTitle = false,
  classes: overrideClasses = { title: null, close: null },
  titleClass = undefined,
  childrenClass = undefined,
  mobileFullSize = true,
  ...props
}) => {
  const { isMedium, isNotSmall } = useBreakpoint()
  const showTitle = showTitleOnMobile || isNotSmall

  const extraPaperProps = React.useMemo(
    () => ({
      style: !isMedium
        ? {
            borderRadius: '7px'
          }
        : {
            minWidth: mobileFullSize ? resWidth : 'unset',
            width: mobileFullSize ? resWidth : 'unset',
            maxWidth: mobileFullSize ? resWidth : 'unset',
            minHeight: mobileFullSize ? resHeight : 'unset',
            height: mobileFullSize ? resHeight : 'unset',
            maxHeight: mobileFullSize ? resHeight : 'unset',
            top: '50%',
            left: '50%',
            borderRadius: '0'
          }
    }),
    [isMedium, mobileFullSize]
  )

  const classes = useStyles()
  const hasTitle = !hideTitle && showTitle

  if (!props.open) {
    return null
  }

  return (
    <Modal
      PaperProps={merge(
        PaperProps,
        basePaperProps,
        extraPaperProps,
        PaperProps2
      )}
      {...props}
    >
      <div
        data-testid='modal'
        className={clsx(variant ? classes[variant] : classes.root, className)}
      >
        <div className={classes.titleRow}>
          {hasTitle ? (
            <div className={clsx(classes.title, overrideClasses.title)}>
              {title}
            </div>
          ) : (
            <div />
          )}

          {showX && (
            <IconButton
              data-testid='close-btn'
              className={classes.close}
              onClick={props.onClose}
            >
              <CloseCircle />
            </IconButton>
          )}
        </div>
        <div className={clsx(classes.children, childrenClass)}>{children}</div>
      </div>
    </Modal>
  )
}

export default BaseModal
